/**
 * To be used with the 'chunky-button' variant of the radio component.
 */

import { Icon } from '@/components/icon';
import { Text } from '@/components/text';
import { tv } from '@/utils/styles';

interface Props {
  icon: string;
  heading: string;
  body?: string;
  variant?: 'inline';
  size?: 'sm';
  iconSize?: 'sm' | 'md' | 'lg' | 'xl' | string;
  iconColor?: string;
}

const RadioButtonInner = ({ icon, heading, body, variant, size, iconSize = 'xl', iconColor }: Props) => {
  const { base, inner, text, subText } = radioInnerStyles({ variant, size });
  return (
    <div className={base()}>
      <Icon size={iconSize} name={icon} color={iconColor} />
      <span className={inner()}>
        <Text variant="secondary" className={text()} as="span">
          {heading}
        </Text>
        {body && (
          <Text variant="sm" className={subText()} as="span">
            {body}
          </Text>
        )}
      </span>
    </div>
  );
};

const radioInnerStyles = tv({
  slots: {
    base: 'block h-full',
    inner: 'ml-0 mt-2 block',
    text: 'block pb-0.5 font-semibold',
    subText: 'mb-0 block leading-snug',
  },
  variants: {
    variant: {
      inline: {
        base: 'flex items-center',
        inner: 'ml-4 mt-0',
      },
    },
    size: {
      sm: {
        base: 'h-6',
        inner: 'ml-2',
      },
    },
  },
});

export { RadioButtonInner };
